import React from 'react';
import { Sparkles } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function PoweredBySection() {
  const {
    ref,
    isRevealed
  } = useScrollReveal();
  return <section className="py-20 relative overflow-hidden" data-id="element-163">
      <div className="container mx-auto px-4 flex justify-center" data-id="element-164">
        <div ref={ref} className={`relative max-w-3xl w-full bg-[#080808] border border-[#c9a84c]/30 rounded-xl p-8 md:p-12 text-center transition-all duration-1000 transform ${isRevealed ? 'opacity-100 scale-100' : 'opacity-0 scale-95'} shadow-[inset_0_0_40px_-10px_rgba(201,168,76,0.1)]`} data-id="element-165">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#050505] px-4 py-1" data-id="element-166">
            <div className="flex items-center gap-2 text-[#c9a84c] text-sm font-medium tracking-widest uppercase" data-id="element-167">
              <Sparkles className="h-4 w-4" data-id="element-168" />
              <span data-id="element-169">Technology</span>
            </div>
          </div>

          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-170">
            Powered by <span className="text-[#c9a84c]" data-id="element-171">Magic Patterns</span>
          </h3>

          <p className="text-gray-400 leading-relaxed max-w-2xl mx-auto" data-id="element-172">
            Our proprietary AI engine analyzes thousands of high-converting
            designs to generate layouts that are not just beautiful, but
            scientifically optimized for engagement and conversion.
          </p>
        </div>
      </div>
    </section>;
}